export default __webpack_public_path__ + "static/media/50.d6aea32b.svg";